import { z } from 'zod'

import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import {
  dailySignalsQueryOptions,
  indexSymbolsQueryOptions,
  signalSessionsQueryOptions,
} from '@/features/signals/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { sessionDateParamSchema, sideParamSchema } from '@/screens/signals/search'

export const dailyForecastSearchSchema = z.object({
  date: sessionDateParamSchema,
  side: sideParamSchema,
})

/**
 * The `/market/signals/daily` loader. MAIN: the after-close boards for the
 * entry URL's session (the screen keeps reading with `keepPreviousData`, so
 * a session change holds the boards in place under RefreshRegion's refresh
 * line). SECONDARY: the session list and the index symbols (which rows link).
 */
export async function loadDailyForecast({
  context: { queryClient },
  location,
  preload,
}: {
  context: RouterContext
  location: { search: unknown }
  preload: boolean
}): Promise<void> {
  const { date } = dailyForecastSearchSchema.parse(location.search)
  if (!preload) {
    prefetchRouteData(queryClient, signalSessionsQueryOptions())
    prefetchRouteData(queryClient, indexSymbolsQueryOptions())
  }
  await ensureRouteData(queryClient, dailySignalsQueryOptions(date ?? null))
}
